import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { createMicroApp, unmountMicroApp } from "@ice/stark";
import { Spin } from "antd";
import { getMenus } from "@/services";
import { findMenuTreeNode, isPreview, registerSdk } from "@/utils";
import RenderErrorFallback from "./render-error-fallback";
import styles from "./index.module.css";

const MaterialPage = () => {
  const container = useRef(null);
  const { pathname: path } = useLocation();
  const isPreviewMode = isPreview();

  const [subAppError, setSubAppError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  /**
   * path 变化时说明发生了页面切换
   * 需要重新触发页面渲染
   */

  useEffect(() => {
    // 将当前 path 作为子应用的名称, 用于加载和卸载
    const currentAppName = path;

    const getPageInfo = async () => {
      const { menus } = await getMenus();

      // 找到这个path对应菜单项的详细信息
      const res = findMenuTreeNode(menus, path);
      const { materialDraftInfo, materialFormalInfo } = res;

      let bunles = [];
      try {
        bunles = isPreviewMode
          ? JSON.parse(materialDraftInfo.bundle)
          : JSON.parse(materialFormalInfo.bundle);
      } catch (error) {
        console.error("error", error);
      }

      const client = await registerSdk;

      // 加载子应用
      await createMicroApp(
        {
          container: container.current,
          name: currentAppName,
          url: bunles,
          loadScriptMode: "import",
          sandbox: true,
          props: {
            sdkClient: client,
            onError: (err) => {
              setSubAppError(err);
              console.log("onErroronErroronError", err);
            },
          },
        },
        {
          // beforeMount: (appConfig) => {
          //   console.log("beforeMount", appConfig);
          // },
          // afterMount: (appConfig) => {
          //   console.log("afterMount", appConfig);
          // },
          // beforeUnmount: (appConfig) => {
          //   console.log("beforeUnmount", appConfig);
          // },
          // afterUnmount: (appConfig) => {
          //   console.log("afterUnmount", appConfig);
          // },
        },
        {
          onLoadingApp: () => {
            setIsLoading(true);
          },
          onFinishLoading: () => {
            setIsLoading(false);
          },
          onError: (err) => {
            console.log("onError", err);
            setIsLoading(false);
          },
          // shouldAssetsRemove: (assetUrl, element) => {
          //   // TODO: 只移除微应用动态加载上的资源
          //   if (element.getAttribute("icestark") === "dynamic") {
          //     return true;
          //   }
          //   return false;
          // },
        },
      );
    };

    getPageInfo();

    return () => {
      // 卸载子应用
      unmountMicroApp(currentAppName);
      setSubAppError(null);
    };
  }, [path, isPreviewMode]);

  return (
    <Spin tip="Loading..." spinning={isLoading}>
      <div key={path} className={styles.materialPage} ref={container}>
        {subAppError && <RenderErrorFallback error={subAppError} />}
      </div>
    </Spin>
  );
};

export default MaterialPage;
